<!-- 财务状况与音像制品出版汇总表 -->

<template>
  <div class="tabCage table5E">
    <div class="tabTtl">
      <span>表 5：获得表彰情况登记表</span>
    </div>
    <div class="editArea">
      <table>
        <tr>
          <td class="edName">奖项名称：</td>
          <td class="edInpBig">
            <el-input v-model="params.hjName" disabled size="small"></el-input>
          </td>
        </tr>
        <tr>
          <td class="edName">表彰对象：</td>
          <td class="edInp">
            <el-select v-model="params.bzObject" disabled size="small" placeholder="请选择">
              <el-option v-for="item in dicDats['C023']" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="edName">奖励内容：</td>
          <td class="edInpTextArea">
            <el-input :rows="3" type="textarea" v-model="params.commend" disabled size="small"></el-input>
          </td>
        </tr>
        <tr>
          <td class="edName">颁奖单位：</td>
          <td class="edInp">
            <el-input v-model="params.bjName" disabled size="small"></el-input>
          </td>
        </tr>
        <tr>
          <td class="edName">获奖级别：</td>
          <td class="edInp edSelect">
            <el-select v-model="params.hjLevel" disabled size="small" placeholder="请选择">
              <el-option v-for="item in dicDats['C024']" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <el-input
              v-if="dicMap['C024'][params.hjLevel] == '其他'"
              v-model="params.hjLevelOther"
              disabled
              size="small"></el-input>
          </td>
        </tr>
        <tr>
          <td class="edName">表彰时间：</td>
          <td class="edInp">
            <el-input v-model="params.hjDate" disabled size="small"></el-input>
            <!-- <el-date-picker
                        disabled
                        v-model="params.hjDate"
                        align="right"
                        type="date"
                        size="small"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                      </el-date-picker> -->
          </td>
        </tr>
      </table>
    </div>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt5";
import { tabUpdate5, tabRead5 } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      dicDats: {},
      submiting: false,

      dicMap: {},
    };
  },
  methods: {
    dictInit: function () {
      let nameArr = ["C023", "C024"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then((result) => {
        this.dicDats = result;
        this.dicMap["C024"] = this.$store.getters.dictionary["C024"];
      });
    },

    tabReEdit: function () {
      tabRead5({ id: this.$route.query.id }).then((response) => {
        this.params = response.pcommend;
      });
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },

  created: function () {
    this.dictInit();
    this.tabReEdit();
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";
.table5E .edInp .el-textarea {
  width: 450px;
}
</style>



// WEBPACK FOOTER //
// table5.vue?4eae24a0